export default __webpack_public_path__ + "static/media/startingDateOfStay.82cef4fc.svg";